var _rect, _rect2, _g, _g2, _path, _rect3, _rect4, _rect5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQnsLandingViewIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 123,
    viewBox: "0 0 128 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.0456032,
    y: 123,
    width: 107.381,
    height: 103.665,
    rx: 8.29762,
    transform: "rotate(-90 0 123)",
    fill: "#042261",
    fillOpacity: 0.73
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.0456032,
    x: 24.3346,
    y: 107.381,
    width: 107.381,
    height: 103.665,
    rx: 8.29762,
    transform: "rotate(-90 24.3346 107.381)",
    fill: "#042261",
    fillOpacity: 0.73
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3942_2554)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 113.643,
    y: 26.6426,
    width: 69,
    height: 99.2852,
    rx: 7.32143,
    transform: "rotate(90 113.643 26.6426)",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_3942_2554)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.5,
    y: 36.5,
    width: 20,
    height: 20,
    rx: 10,
    fill: "white",
    fillOpacity: 0.59
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.0119,
    y: 36.0119,
    width: 20.9762,
    height: 20.9762,
    rx: 10.4881,
    stroke: "#A0A0A3",
    strokeWidth: 0.97619
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.1716 41.8019C32.1716 41.0829 32.7663 40.5 33.5 40.5C34.2337 40.5 34.8284 41.0829 34.8284 41.8019C34.8284 42.0389 34.7638 42.261 34.651 42.4524C36.405 42.9618 37.2649 44.7146 37.2939 47.315C37.3 47.8652 37.4694 48.2253 37.7686 48.5029C37.7138 48.452 38.5 48.987 38.5 49.2985C38.5 49.5207 38.3162 49.7008 38.0895 49.7008H35.408C35.2431 50.7151 34.4655 51.5 33.5 51.5C32.5345 51.5 31.7569 50.7151 31.592 49.7008H28.9105C28.6838 49.7008 28.5 49.5207 28.5 49.2985C28.5 49.044 29.0569 48.6248 29.193 48.5294L29.2224 48.5101C29.5232 48.2215 29.6939 47.8543 29.6982 47.3163C29.719 44.6959 30.5813 42.9532 32.3475 42.4497C32.2356 42.2589 32.1716 42.0377 32.1716 41.8019ZM32.428 49.7008C32.569 50.2834 33.0073 50.6954 33.5 50.6954C33.9927 50.6954 34.431 50.2834 34.572 49.7008H32.428ZM33.5 43.1038C31.503 43.1038 30.541 44.5717 30.5192 47.3225C30.5141 47.9657 30.3239 48.4719 29.9918 48.8751L29.9728 48.8955H37.0199L36.9193 48.7704C36.6666 48.4293 36.5126 48.0128 36.4795 47.4988L36.4729 47.3238C36.4425 44.5925 35.4797 43.1038 33.5 43.1038ZM33.5 42.2992C33.7802 42.2992 34.0074 42.0765 34.0074 41.8019C34.0074 41.5273 33.7802 41.3046 33.5 41.3046C33.2198 41.3046 32.9926 41.5273 32.9926 41.8019C32.9926 42.0765 33.2198 42.2992 33.5 42.2992Z",
    fill: "#A0A0A3"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 49.5,
    y: 41.5,
    width: 54,
    height: 9.04348,
    fill: "#5A6479"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 49.5,
    y: 56.5435,
    width: 54,
    height: 9.04348,
    fill: "#5A6479"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 49.5,
    y: 71.5869,
    width: 54,
    height: 9.04348,
    fill: "#5A6479"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3942_2554",
    x: 8.35742,
    y: 23.6426,
    width: 111.285,
    height: 81,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3942_2554"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3942_2554"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3942_2554",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_3942_2554",
    x: 18.5238,
    y: 34.5239,
    width: 29.9524,
    height: 29.9521,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.24446 0 0 0 0 0.270514 0 0 0 0 0.341231 0 0 0 0.369373 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3942_2554"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3942_2554",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQnsLandingViewIcon);
export default __webpack_public_path__ + "static/media/QNSLandingViewIcon.9b90e3cddec2b153c82d677a81f1a2af.svg";
export { ForwardRef as ReactComponent };